import { render, staticRenderFns } from "./ListEntrees.vue?vue&type=template&id=213dbf3a&"
import script from "./ListEntrees.vue?vue&type=script&lang=js&"
export * from "./ListEntrees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports